module.exports = __webpack_public_path__ + "media/warranty-claim/warning-c92dbcf1.svg";